import { readCache } from 'lib/indexedDbCache';
import { ACCOUNT_USERS_RETENTION_MS } from 'constants/cache/accountUsersCache';

import { buildAccountUsersCacheKey } from './buildAccountUsersCacheKey';

/**
 * Reads the cached PK_User → UUID pairs for one account.
 *
 * The mapping is immutable, so freshness is irrelevant here — we pass the retention window as the
 * TTL only to satisfy `readCache` and ignore the resulting `isStale` flag. When the environment is
 * unknown the key is `null` and we skip the cache, returning an empty map.
 *
 * @param {string|number} PK_Account - Account whose bucket to read.
 * @returns {Promise<Object>} Map of PK_User → UUID (empty object when nothing is cached).
 */
export const readAccountUsersBucket = async (PK_Account) => {
    const key = buildAccountUsersCacheKey(PK_Account);
    if (!key) {
        return {};
    }

    const cached = await readCache(key, ACCOUNT_USERS_RETENTION_MS);

    return cached?.data?.pairs ?? {};
};
